export default __webpack_public_path__ + "static/fox_sell-3c7fcadae644fed310288b5211a07f64.svg";